export default __webpack_public_path__ + "static/botw-traditional-quest-2x1-d4bc54ff899ec18e7781ab726ca139ae.jpg";